import AnnouncementBar from "@/components/aeonyx/AnnouncementBar";
import Header from "@/components/aeonyx/Header";
import Hero from "@/components/aeonyx/Hero";
import ProductGallery from "@/components/aeonyx/ProductGallery";
import Configurator from "@/components/aeonyx/Configurator";
import ProblemSection from "@/components/aeonyx/ProblemSection";
import FeaturesGrid from "@/components/aeonyx/FeaturesGrid";
import QualityControl from "@/components/aeonyx/QualityControl";
import Testimonials from "@/components/aeonyx/Testimonials";
import SizeGuide from "@/components/aeonyx/SizeGuide";
import Comparison from "@/components/aeonyx/Comparison";
import HowItWorks from "@/components/aeonyx/HowItWorks";
import FAQ from "@/components/aeonyx/FAQ";
import Blogs from "@/components/aeonyx/Blogs";
import Coupons from "@/components/aeonyx/Coupons";
import FinalCTA from "@/components/aeonyx/FinalCTA";
import Footer from "@/components/aeonyx/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useScrollReveal } from "@/lib/useScrollReveal";

export default function Landing() {
  useScrollReveal();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.accessDenied) {
      toast.error("You are not authorized to access that page.");
      // clear the state so it doesn't fire again on back-nav
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div data-testid="landing-page" className="bg-cool-white text-navy-deep">
      <AnnouncementBar />
      <Header />
      <Hero />
      <ProductGallery />
      <Configurator />
      <ProblemSection />
      <FeaturesGrid />
      <QualityControl />
      <Testimonials />
      <SizeGuide />
      <Comparison />
      <HowItWorks />
      <FAQ />
      <Coupons />
      <Blogs />
      <FinalCTA />
      <Footer />
      {/* Spacer for mobile sticky bar */}
      <div className="h-20 lg:hidden" aria-hidden="true" />
    </div>
  );
}
